import React from "react";

import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";

import { ErrorModalProps } from "../../types/ErrorModalProps";

export default function ErrorModal({
  isVisible,
  onConfirm,
  onClose,
  message,
  title,
  confirmButtonText,
  cancelButtonText,
  isCancelable = false,
}: ErrorModalProps) {
  const footerContent = (
    <div className="flex flex-row gap-x-2 justify-center">
      {isCancelable && (
        <button
          onClick={onClose}
          // className="px-4 py-2 rounded-3xl text-svvh-green bg-white border border-svvh-green hover:bg-svvh-light-green w-[120px]"
          className="gold-submit-btn-outlined w-[200px]"
        >
          {cancelButtonText || "ยกเลิกการรับบริการ"}
        </button>
      )}
      <button
        onClick={onConfirm}
        // className="px-4 py-2 rounded-3xl text-white w-[200px] bg-svvh-green hover:bg-green-700"
        className="px-4 py-2 rounded-3xl text-white w-[200px]  gold-submit-btn"
      >
        {confirmButtonText || "ฝากข้อความ"}
      </button>
    </div>
  );

  return (
    <div className="font-prompt flex justify-content-center">
      <Dialog
        header={
          <div className="w-full text-center font-semibold text-xl sm:text-2xl">
            {title || "ขออภัยในความไม่สะดวก"}
          </div>
        }
        visible={isVisible}
        position={"center"}
        onHide={onClose}
        footer={footerContent}
        draggable={false}
        resizable={false}
        closable={false}
        style={{ width: "100%", maxWidth: "800px" }}
      >
        <div className="flex flex-col text-center text-md sm:text-lg">
          <div className="border boder-t-2 mb-6"></div>
          <span>{message}</span>
        </div>
      </Dialog>
    </div>
  );
}
